import { DialogStepSchema } from '@feedyou-ai/feedbot-schema'

import { UnsetDialogsService } from '../../../types'

export const unsetDialogs: UnsetDialogsService<DialogStepSchema> = (dialogIds, step) => {
  if (!dialogIds.includes(step.dialog)) {
    return step
  }
  const newStep = { ...step }
  // @ts-ignore
  delete newStep.dialog

  return newStep
}
